import { Icon, Icons, Tooltip } from '@silverfort/sf-components';

const Tabs = ({ tabs = [], selectedTab = 0, disabledTabs = [], onClick, className }) => {
    return (
        <div className={`text-13 flex box-border items-center h-12 border-b border-sf-gray-100 ${className}`}>
            {tabs.map((tab, i) => {
                const isDisabled = disabledTabs.includes(tab.value);
                const isSelectable = tab.value !== selectedTab && !isDisabled;
                const isSelected = tab.value === selectedTab;
                return (
                    <div
                        key={i}
                        onClick={isDisabled ? () => {} : () => onClick(tab.value)}
                        className={`font-sf p-2 h-full ${
                            isSelected ? 'border-b-2 border-sf-primary-500 text-sf-primary-500' : ''
                        } ${isSelectable ? 'cursor-pointer text-sf-gray-500' : ''} ${
                            isDisabled ? 'text-sf-gray-300 cursor-not-allowed' : ''
                        }`}>
                        <div
                            className={`flex gap-1 items-center justify-center h-8 min-w-18 p-2 ${
                                isSelectable ? 'hover:bg-sf-gray-50 rounded-lg ' : ''
                            }`}>
                            <div className="whitespace-nowrap">{tab.name}</div>
                            {tab.tooltip && (
                                <Tooltip title={<div>{tab.tooltip}</div>}>
                                    <Icon
                                        className={isSelected ? 'text-[#188DED]' : 'text-[##808080]'}
                                        size={12}
                                        icon={Icons.Info}
                                    />
                                </Tooltip>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Tabs;
